// protected-route.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({
  children,
  adminOnly = false,
  allowedEmails = [],
  excludedEmails = [],
  employeesOnly = false, // YENİ: Sadece employee'lar için
}) => {
  const userName = localStorage.getItem("first_name");
  const userEmail = localStorage.getItem("email");
  const userType = localStorage.getItem("user_type"); // YENİ: user_type kontrolü

  if (!userName) return <Navigate to="/" />;

  // YENİ: Employees only kontrolü
  if (employeesOnly && userType !== "employee") {
    return <Navigate to="/home" />;
  }

  // Excluded emails kontrolü
  if (excludedEmails.length > 0 && excludedEmails.includes(userEmail)) {
    return <Navigate to="/home" />;
  }

  // Admin kontrolü
  if (
    adminOnly &&
    !["admin@customzonpod.com", "mhmtmnctl20@gmail.com"].includes(userEmail)
  ) {
    return <Navigate to="/home" />;
  }

  // allowedEmails kontrolü (boş değilse)
  if (allowedEmails.length > 0 && !allowedEmails.includes(userEmail)) {
    return <Navigate to="/home" />;
  }

  return children;
};

export default ProtectedRoute;
